export default __webpack_public_path__ + "static/media/ai.d99eb8e0.png";